var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Hero'),_c('Our-community'),_c('Video'),_c('Affiliate'),_c('LatestNews'),_c('Subscribe')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }